import React, { useContext, useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { TestsContext } from "../../contexts";

export const LatencyChart = (props) => {
  const { tests } = useContext(TestsContext);
  const [chartData, setData] = useState(null);

  useEffect(() => {
    if (tests.times && tests.times[props.index]) {
      // Set the chart data.
      let d = [["", ""]];

      for (var n = 0; n < tests.times[props.index].length; ++n) {
        d.push([n + 1, tests.times[props.index][n]]);
      }
      setData(d);
    }
  }, [tests, props.index]);

  const hasData = () => {
    return tests.times && tests.times[props.index];
  };

  var options = {
    legend: "none",
    pointSize: 3,
    series: [{ color: "grey" }],
    hAxis: {
      textPosition: "none",
      gridlines: {
        count: 1,
      },
    },
    vAxis: {
      format: "# ms",
      minValue: 0,
      gridlines: {
        xcount: 1,
      },
    },
  };

  return (
    <>{hasData() && <Chart chartType='ColumnChart' width='100%' height='100%' data={chartData} options={options} />}</>
  );
};
